import { Outlet, useLocation } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { MobileHeader } from './MobileHeader'
import { Breadcrumbs } from './Breadcrumbs'
import { ReadOnlyBanner } from './ReadOnlyBanner'
import { FeedbackFAB } from '@features/feedback/components/FeedbackFAB'
import { useUIStore } from '@store/uiStore'
import { clsx } from 'clsx'

export function AppLayout() {
  const { sidebarOpen, sidebarCollapsed, contentFullWidth } = useUIStore()
  // The home page hosts the wide review-queue tables, so give it ~25% more room
  // (1600px) than the standard 1280px (max-w-7xl) cap used on every other page.
  // The quote builder runs three side-by-side lanes, so let it use 90% of the
  // available width (everything beside the sidebar) rather than the 1280px cap.
  const pathname = useLocation().pathname
  const isHome = pathname === '/home'
  const isQuote = pathname === '/quote'
  const isTestingGround = pathname === '/dashboard/implementations/testing-ground'
  // contentFullWidth lets a feature request full width for a specific in-page
  // view (e.g. the Workflow Builder stage inside Platform Journey).
  const isFullWidth = isTestingGround || contentFullWidth

  return (
    <div className="flex h-screen" style={{ backgroundColor: 'var(--bg-primary)' }}>
      {/* Mobile Header */}
      <MobileHeader />

      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main
        className={clsx(
          'flex-1 overflow-auto transition-all duration-300',
          'pt-14 md:pt-0', // Account for mobile header
          sidebarOpen
            ? sidebarCollapsed
              ? 'md:ml-sidebar-collapsed'
              : 'md:ml-sidebar'
            : 'md:ml-0'
        )}
      >
        <div className={clsx('p-4 md:p-6 mx-auto', isHome ? 'max-w-[1600px]' : isQuote ? 'max-w-[90%]' : isFullWidth ? 'max-w-none' : 'max-w-7xl')}>
          <ReadOnlyBanner />
          <Breadcrumbs />
          <Outlet />
        </div>
      </main>

      {/* Global Feedback Button */}
      <FeedbackFAB />
    </div>
  )
}
